module.exports = __webpack_public_path__ + "static/media/logout-white.71a8528e.svg";